<template>
  <div></div>
</template>

<script>
import firebase from "firebase/app"

/**
 * Sign up with email link callback
 */
export default {
  // local state
  data() {
    return {
      isNewUser: false
    }
  },

  /**
   * Process code
   */
  async mounted() {
    await this.processEmailAuth()
  },

  // handle notification
  notifications: {
    notifyError: {
      type: "error"
    }
  },

  // components functions
  methods: {
    /**
     * Process email auth
     */
    async processEmailAuth() {
      await this.handleEmailAuth()

      const redirectPath = this.isNewUser ? "/new-user" : "/"
      this.$router.push(redirectPath)
    },

    /**
     * handle email auth
     */
    async handleEmailAuth() {
      try {
        // Confirm the link is a sign-in with email link.
        if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
          // pull email from local storage
          let email = localStorage.getItem("emailForSignIn")
          if (!email) {
            // User opened the link on a different device. To prevent session fixation
            // attacks, ask the user to provide the associated email again. For example:
            email = window.prompt("Please provide your email for confirmation")
          }

          // complate sign up
          const userCredential = await firebase
            .auth()
            .signInWithEmailLink(email, window.location.href)

          // check if the user is new user
          this.isNewUser = userCredential.additionalUserInfo.isNewUser || false

          // clean storage
          localStorage.removeItem("emailForSignIn")
        }
      } catch (e) {
        console.error(e)
        this.notifyError({
          title: this.$t("errors.unableToAuthenticateTitle"),
          message: e.message
        })
      }
    }
  }
}
</script>
